import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CopyrightComponent } from '../copyright/copyright.component';

@Component({
  selector: 'lv-password-reset-success',
  templateUrl: 'password-reset-success.component.html',
  styleUrls: ['password-reset-success.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule, TranslateModule, CopyrightComponent]
})
export class PasswordResetSuccessComponent {}
